export default {
    topics: [
        {
            title: ' File ',
            href: 'm-File-File.html',
            attributes: { 'data-id': 'm-File-File' },
            menu: { hasChildren: false },
            tocID: 'm-File-File-d66e4869',
            topics: [],
        },
        {
            title: ' canRead ',
            href: 'p-File-canRead.html',
            attributes: { 'data-id': 'p-File-canRead' },
            menu: { hasChildren: false },
            tocID: 'p-File-canRead-d66e4877',
            topics: [],
        },
        {
            title: ' canWrite ',
            href: 'p-File-canWrite.html',
            attributes: { 'data-id': 'p-File-canWrite' },
            menu: { hasChildren: false },
            tocID: 'p-File-canWrite-d66e4885',
            topics: [],
        },
        {
            title: ' close ',
            href: 'm-File-close.html',
            attributes: { 'data-id': 'm-File-close' },
            menu: { hasChildren: false },
            tocID: 'm-File-close-d66e4893',
            topics: [],
        },
        {
            title: ' copyTo ',
            href: 'm-File-copyTo.html',
            attributes: { 'data-id': 'm-File-copyTo' },
            menu: { hasChildren: false },
            tocID: 'm-File-copyTo-d66e4901',
            topics: [],
        },
        {
            title: ' dispose ',
            href: 'm-File-dispose.html',
            attributes: { 'data-id': 'm-File-dispose' },
            menu: { hasChildren: false },
            tocID: 'm-File-dispose-d66e4909',
            topics: [],
        },
        {
            title: ' exists ',
            href: 'p-File-exists.html',
            attributes: { 'data-id': 'p-File-exists' },
            menu: { hasChildren: false },
            tocID: 'p-File-exists-d66e4917',
            topics: [],
        },
        {
            title: ' flush ',
            href: 'm-File-flush.html',
            attributes: { 'data-id': 'm-File-flush' },
            menu: { hasChildren: false },
            tocID: 'm-File-flush-d66e4925',
            topics: [],
        },
        {
            title: ' fullName ',
            href: 'p-File-fullName.html',
            attributes: { 'data-id': 'p-File-fullName' },
            menu: { hasChildren: false },
            tocID: 'p-File-fullName-d66e4933',
            topics: [],
        },
        {
            title: ' isDirectory ',
            href: 'p-File-isDirectory.html',
            attributes: { 'data-id': 'p-File-isDirectory' },
            menu: { hasChildren: false },
            tocID: 'p-File-isDirectory-d66e4941',
            topics: [],
        },
        {
            title: ' isFile ',
            href: 'p-File-isFile.html',
            attributes: { 'data-id': 'p-File-isFile' },
            menu: { hasChildren: false },
            tocID: 'p-File-isFile-d66e4950',
            topics: [],
        },
        {
            title: ' isOpen ',
            href: 'p-File-isOpen.html',
            attributes: { 'data-id': 'p-File-isOpen' },
            menu: { hasChildren: false },
            tocID: 'p-File-isOpen-d66e4958',
            topics: [],
        },
        {
            title: ' lastModified ',
            href: 'p-File-lastModified.html',
            attributes: { 'data-id': 'p-File-lastModified' },
            menu: { hasChildren: false },
            tocID: 'p-File-lastModified-d66e4966',
            topics: [],
        },
        {
            title: ' list ',
            href: 'm-File-list.html',
            attributes: { 'data-id': 'm-File-list' },
            menu: { hasChildren: false },
            tocID: 'm-File-list-d66e4974',
            topics: [],
        },
        {
            title: ' mkdir ',
            href: 'm-File-mkdir.html',
            attributes: { 'data-id': 'm-File-mkdir' },
            menu: { hasChildren: false },
            tocID: 'm-File-mkdir-d66e4982',
            topics: [],
        },
        {
            title: ' name ',
            href: 'p-File-name.html',
            attributes: { 'data-id': 'p-File-name' },
            menu: { hasChildren: false },
            tocID: 'p-File-name-d66e4990',
            topics: [],
        },
        {
            title: ' open ',
            href: 'm-File-open.html',
            attributes: { 'data-id': 'm-File-open' },
            menu: { hasChildren: false },
            tocID: 'm-File-open-d66e4998',
            topics: [],
        },
        {
            title: ' path ',
            href: 'p-File-path.html',
            attributes: { 'data-id': 'p-File-path' },
            menu: { hasChildren: false },
            tocID: 'p-File-path-d66e5006',
            topics: [],
        },
        {
            title: ' readln ',
            href: 'm-File-readln.html',
            attributes: { 'data-id': 'm-File-readln' },
            menu: { hasChildren: false },
            tocID: 'm-File-readln-d66e5014',
            topics: [],
        },
        {
            title: ' remove ',
            href: 'm-File-remove.html',
            attributes: { 'data-id': 'm-File-remove' },
            menu: { hasChildren: false },
            tocID: 'm-File-remove-d66e5022',
            topics: [],
        },
        {
            title: ' renameTo ',
            href: 'm-File-renameTo.html',
            attributes: { 'data-id': 'm-File-renameTo' },
            menu: { hasChildren: false },
            tocID: 'm-File-renameTo-d66e5030',
            topics: [],
        },
        {
            title: ' rmdir ',
            href: 'm-File-rmdir.html',
            attributes: { 'data-id': 'm-File-rmdir' },
            menu: { hasChildren: false },
            tocID: 'm-File-rmdir-d66e5039',
            topics: [],
        },
        {
            title: ' size ',
            href: 'p-File-size.html',
            attributes: { 'data-id': 'p-File-size' },
            menu: { hasChildren: false },
            tocID: 'p-File-size-d66e5047',
            topics: [],
        },
        {
            title: ' writeln ',
            href: 'm-File-writeln.html',
            attributes: { 'data-id': 'm-File-writeln' },
            menu: { hasChildren: false },
            tocID: 'm-File-writeln-d66e5055',
            topics: [],
        },
    ],
};

